/**
 * The post of a comment: the channel logo in the chat header is a link to
 * GET /api/v1/conversations/:id/platform-link/open (api/app/platform_link.py), which redirects the new tab to the post
 * (Facebook: scrolled to the comment). This file only says whether there is a page and what the tooltip says (same
 * wording as the server). LINE / Messenger / Instagram 1:1 work from pasted links: lib/platformChat.ts.
 */
import type { Channel, ConversationKind } from '../api/types'

export interface PlatformLinkInfo {
  /** tooltip + accessible name */
  title: string
}

export function platformLinkInfo(channel: Channel, kind: ConversationKind | undefined, isHistory = false): PlatformLinkInfo | null {
  if (channel === 'web' || isHistory) return null // no platform page: web chat, history imported from LINE
  if (kind === 'comment') {
    if (channel === 'fb') return { title: 'เปิดคอมเมนต์นี้บน Facebook' }
    if (channel === 'ig') return { title: 'เปิดโพสต์นี้บน Instagram · คอมเมนต์อยู่ใต้โพสต์' }
    return null
  }
  // LINE / Messenger / Instagram 1:1: neither app opens one customer's chat from API ids, the link comes from what
  // people pasted — lib/platformChat.ts
  return null
}

/** Mock mode has no API behind it: the platform's front page instead of a broken tab. */
const MOCK_HOME: Record<Exclude<Channel, 'web'>, string> = {
  line: 'https://chat.line.biz/',
  fb: 'https://business.facebook.com/latest/inbox/all',
  ig: 'https://business.facebook.com/latest/inbox/all',
}

export function platformLinkHref(
  convId: string,
  channel: Channel,
  opts: { mock?: boolean; base?: string; origin?: string } = {},
): string {
  if (opts.mock) return channel === 'web' ? '#' : MOCK_HOME[channel]
  const base = (opts.base ?? '').trim().replace(/\/+$/, '')
  const path = `${base}/api/v1/conversations/${encodeURIComponent(convId)}/platform-link/open`
  return opts.origin ? new URL(path, opts.origin).toString() : path
}
